import React from 'react'

import { t } from 'src/translations'

import { getCreditCardImage } from 'public/components/default_template/online_ordering/checkout/payment/SavedCreditCards'

type SavedCreditCardProps = {
  maskedPan: string
  expirationMonth?: string | null
  expirationYear?: string | null
  cardType?: string
}

export const SavedCreditCard = ({
  maskedPan,
  expirationMonth,
  expirationYear,
  cardType
}: SavedCreditCardProps) => {
  return (
    <div className='savedCreditCardContent'>
      {getCreditCardImage(cardType)}
      <div className='savedCard'>
        <div className='maskedCreditCardNumber'>
          {maskedPan.replaceAll('X', '•').replace('-', ' ')}
        </div>
        <div className='expiration'>
          {t('saved-credit-card.exp', { expirationMonth, expirationYear })}
        </div>
      </div>
    </div>
  )
}
